import { Card, Box, Icon, Text, SimpleGrid } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './Panels.css';
import click from './sounds/shortclick.mp3';
import { FaCircle, FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function Panels() {
    const tindex = useRef(1);
    const [dev, setDev] = useState([]);
    const [displayDev, setDisplayDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [selectedType, setSelectedType] = useState(1);
    const [floorId, setFloorId] = useState(1);

    // Navigation
    const navigate = useNavigate();

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    function handleClick(e) {
        console.log("Button clicked with value:", e); // Add this line
        playClickSound();
        setFloorId(e);
    };

    function handleVBClick(e, f) {
        navigate(`/vibration?device1=${e}&device2=${f}`);
        playClickSound();
    };

    // Create a connection to the hub
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    useEffect(() => {

        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    type: item.type,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    unit: item.unit
                }));

                let paneldevices = deviceDetails.filter(d => d.data_type === 13);
                console.log("PanelDev:", paneldevices);

                setDev(paneldevices); // Store all panel devices
                setDisplayDev(paneldevices);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };
        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        // Register a handler for receiving device data from the hub
        connection.on("ReceiveDeviceData", () => {
            // Update the state with the new device data
            console.log("Updating....")
            getData();
        });
    }, []);

    useEffect(() => {
        console.log("DisplayDev updated:", displayDev);
    }, [displayDev]);

    function FFreshList() {
        if (!displayDev || displayDev.length === 0) {
            return <div>No devices to display</div>;
        }
        if (floorId === 1) {
            return (
                <div>
                    <tr className="row">
                        <td className="pumppanelcellstyle1" style={{
                            fontSize: "24px",
                            overflow: "hidden",
                            color: "#202020",
                            backgroundColor: "#A2A2A2",
                        }}>
                            <table>
                                <tr style={{ fontSize: "24px", height: "18px", fontWeight: "bold" }}>斑蝶樓地下低層咸水泵房</tr>
                                <td>
                                    <tr>
                                        <td>#1號泵 L1供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[9].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵 L2供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[9].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵 L3供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[8].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L1供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[10].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L2供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[10].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L3供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[8].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[0].status[0] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[0].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>#1號泵低電壓指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[1].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>無流量指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[1].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>控制迴路正常指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[2].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: Auto</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[3].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: 關</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[4].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: 手動</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[4].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[2].status[1] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[3].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(54, 55)}>
                                            #1號泵震動正常
                                        </div>
                                    </tr>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(56, 57)}>
                                            #2號泵震動正常
                                        </div>
                                    </tr>
                                </td>
                            </table>
                        </td>

                        <td className="pumppanelcellstyle2" style={{
                            fontSize: "24px",
                            overflow: "hidden",
                            color: "#202020",
                            backgroundColor: "#A2A2A2",
                        }}>
                            <table style={{ borderSpacing: "0 10px" }}>
                                <tr style={{ fontSize: "24px", height: "18px", fontWeight: "bold" }}>斑蝶樓地下低層咸水泵房</tr>
                                <td style={{ width: "450px" }}>
                                    <tr>
                                        <td>Roof Tank A 水位控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[5].status[0] === "1" ? "00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank A 水位控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[5].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank B 水位控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[6].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank B 水位控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[6].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水壓控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[7].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水壓控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[7].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                            </table>
                        </td>

                        <td className="pumppanelcellstyle1" style={{
                            fontSize: "24px",
                            overflow: "hidden",
                            color: "#202020",
                            backgroundColor: "#A2A2A2",
                        }}>
                            <table>
                                <tr style={{ fontSize: "24px", height: "18px", fontWeight: "bold" }}>斑蝶樓地下低層食水泵房</tr>
                                <td>
                                    <tr>
                                        <td>#1號泵 L1供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[37].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵 L2供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[37].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵 L3供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[39].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L1供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[33].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L2供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[33].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵 L3供電正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[39].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[25].status[0] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#1號泵故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[25].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>#1號泵低電壓指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[26].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>無流量指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[26].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>控制迴路正常指示</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[27].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: Auto</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[28].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: 關</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[29].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水泵選擇: 手動</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[29].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[27].status[1] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>#2號泵故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[28].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(58, 59)}>
                                            #1號泵震動正常
                                        </div>
                                    </tr>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(60, 61)}>
                                            #2號泵震動正常
                                        </div>
                                    </tr>
                                </td>
                            </table>
                        </td>

                        <td className="pumppanelcellstyle2" style={{
                            fontSize: "24px",
                            overflow: "hidden",
                            color: "#202020",
                            backgroundColor: "#A2A2A2",
                        }}>
                            <table style={{ borderSpacing: "0 10px" }}>
                                <tr style={{ fontSize: "24px", height: "18px", fontWeight: "bold" }}>斑蝶樓地下低層食水泵房</tr>
                                <td style={{ width: "450px" }}>
                                    <tr>
                                        <td>Roof Tank A 水位控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[30].status[0] === "0" ? "00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank A 水位控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[30].status[1] === "0" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank B 水位控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[31].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Roof Tank B 水位控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[31].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水壓控制開關: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[32].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>水壓控制開關: 隔離</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[32].status[0] === "1" ? "#ffff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                            </table>
                        </td>
                    </tr>
                </div>
            );
        } else {
            return (
                <div>
                    <tr className="row">
                        <td className="pumppanelcellstyle4" style={{
                            fontSize: "24px",
                            overflow: "hidden",
                            color: "#202020",
                            backgroundColor: "#A2A2A2",
                        }}>
                            <table>
                                <tr style={{ fontSize: "24px", height: "18px", fontWeight: "bold" }}>斑蝶樓天台食水泵房</tr>
                                <td>
                                    <tr>
                                        <td>泵1 L1供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[16].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵1 L2供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[16].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵1 L3供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[17].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵1: 運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[17].status[0] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵1: 故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[20].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵1: 自動</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[18].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2 L1供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[18].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2 L2供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[19].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2 L3供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[22].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2: 運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[34].status[0] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2: 故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[34].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵2: 自動</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[20].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <td>泵3 L1供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[21].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵3 L2供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[22].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵3 L3供電: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[22].status[1] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵3: 運行</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[35].status[0] === "1" ? "#00ff00" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵3: 故障</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[35].status[1] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>泵3: 自動</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[23].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>控制迴路: 正常</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[23].status[0] === "1" ? "#00ff00" : "red" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>低水位警報</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[24].status[0] === "1" ? "red" : "#ffff80" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>低壓警報</td>
                                        <td>
                                            <FaCircle style={{ color: displayDev[24].status[1] === "1" ? "red" : "ffff80" }} />
                                        </td>
                                    </tr>
                                </td>
                                <td>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(62, 63)}>
                                            #1號泵震動正常
                                        </div>
                                    </tr>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(64, 65)}>
                                            #2號泵震動正常
                                        </div>
                                    </tr>
                                    <tr>
                                        <div className="vbbuttonstyle" style={{ fontSize: "24px", color: "#202020", backgroundColor: "#ffa500", zIndex: 10, position: "relative" }} onClick={() => handleVBClick(66, 67)}>
                                            #3號泵震動正常
                                        </div>
                                    </tr>
                                </td>
                            </table>
                        </td>
                    </tr>
                </div>
            );
        }
    }


    return (
        <div className="containerstyle">
            <table>
                <tbody>
                    <tr>
                        <td style={{ verticalAlign: "top", width: "6%", height: "13.4rem" }}>
                            <div>
                                <div className="bbuttonstyle" style={{ fontSize: "22px", color: floorId === 1 ? "#202020" : "#f5f1eb", backgroundColor: floorId === 1 ? "#BfBfBf" : "#4f4f4f", zIndex: 10, position: "relative" }} onClick={() => handleClick(1)}>
                                    地下低層
                                </div>
                                <div className="bbuttonstyle" style={{ fontSize: "22px", color: floorId === 2 ? "#202020" : "#f5f1eb", backgroundColor: floorId === 2 ? "#BfBfBf" : "#4f4f4f", zIndex: 10, position: "relative" }} onClick={() => handleClick(2)}>
                                    天台
                                </div>
                            </div>
                        </td>
                        <td style={{ verticalAlign: "top", width: "8%", height: "13.4rem" }}>>

                                                <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>
                                                    <tbody>
                                                        <FFreshList />
                                                    </tbody>
                                                </table>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}